/**
 * @module CoreModule
 * @description
 * This is a core module of the application.
 * It is used to include the dependencies that was loaded only one time across the application
 */

import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// Preventing this module only once
import { EnsureModuleLoadedOnceGuard } from '@app/core/EnsureModuleLoadedOnceGuard';

// Importing custom http interceptors
import { ErrorHandlerInterceptor } from '@interceptors/error-handler.interceptor';
import { ApiPrefixInterceptor } from '@interceptors/api-prefix.interceptor';
import { HttpTokenInterceptor } from '@interceptors/http.token.interceptor';
import { TitleService } from '@core/services/title.service';
import { JWTAuthService } from '@core/services/jwt-auth.service';
import { CommonHttpService } from '@core/services/common-http.service';
import { UserService } from '@core/services/user.service';
import { CommonService } from '@core/services/common.service';
import { SessionService } from './services/session.service';
import { TYPES } from '@app/configs/types';
import { PubSubService } from './services/pub-sub-service/pub-sub.service';
import { JwtModule } from "@auth0/angular-jwt";
import { getToken } from './helpers/utils';
import { AuthGuardService } from './services/auth-guard.service';
import { S3Service } from './services/aws/s3.service';
// Adding the http interceptors providers and services
const providers = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorHandlerInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpTokenInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiPrefixInterceptor,
    multi: true,
  },


  {
    provide: TYPES.STORAGE_SERVICE,
    useClass: S3Service
  },


  TitleService,
  JWTAuthService,
  CommonHttpService,
  UserService,
  SessionService,
  CommonService,
  PubSubService,
  AuthGuardService
];

/** @module core */
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return getToken();
        },
        //allowedDomains: ["example.com"],
        //disallowedRoutes: ["http://example.com/examplebadroute/"],
      },
    }),
  ],
  providers: [...providers],
  exports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule, titleService: TitleService) {
    super(parentModule);
    // Changing the title of the application.
    titleService.init();
  }
}
